/**
 * @generated SignedSource<<7a74aadd35812656d4f189fff568b4c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type siteNavigation_AtlassianHubAppShell$data = {
  readonly siteTree: {
    readonly root: {
      readonly contents: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "HelpCenterFolder";
          readonly contents: {
            readonly nodes: ReadonlyArray<{
              readonly __typename: "HelpCenterPage";
              readonly id: string;
              readonly name: {
                readonly default: string;
              } | null;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            }>;
          };
          readonly id: string;
          readonly name: {
            readonly default: string;
          } | null;
        } | {
          readonly __typename: "HelpCenterPage";
          readonly id: string;
          readonly name: {
            readonly default: string;
          } | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        }>;
      };
    } | null;
  } | null;
  readonly " $fragmentType": "siteNavigation_AtlassianHubAppShell";
};
export type siteNavigation_AtlassianHubAppShell$key = {
  readonly " $data"?: siteNavigation_AtlassianHubAppShell$data;
  readonly " $fragmentSpreads": FragmentRefs<"siteNavigation_AtlassianHubAppShell">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "concreteType": "HelpCenterPageName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v2/*: any*/)
    }
  ],
  "type": "HelpCenterPage"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "siteNavigation_AtlassianHubAppShell",
  "selections": [
    {
      "concreteType": "HelpCenterSiteTree",
      "kind": "LinkedField",
      "name": "siteTree",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterFolder",
          "kind": "LinkedField",
          "name": "root",
          "plural": false,
          "selections": [
            {
              "concreteType": "HelpCenterSiteTreeNodeConnection",
              "kind": "LinkedField",
              "name": "contents",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v3/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v1/*: any*/),
                        {
                          "concreteType": "HelpCenterFolderName",
                          "kind": "LinkedField",
                          "name": "name",
                          "plural": false,
                          "selections": (v2/*: any*/)
                        },
                        {
                          "concreteType": "HelpCenterSiteTreeNodeConnection",
                          "kind": "LinkedField",
                          "name": "contents",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "nodes",
                              "plural": true,
                              "selections": [
                                (v0/*: any*/),
                                (v3/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "type": "HelpCenterFolder"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
};
})();

(node as any).hash = "758f2701bd08a1f04afa67c01cd4f843";

export default node;
